var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.scheme,on:{"click":function($event){$event.preventDefault();return _vm.onPressed($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }